

















import { Component, Vue, Watch } from "vue-property-decorator";
import { ActionTypes } from "@/store/aciton-types";
import { UserItem } from "@/response";

@Component({
  props: {
    username: String
  }
})
export default class AuthorComponent extends Vue {
  get author(): UserItem {
    try {
      return (<any>this.$store.state).userStore.author;
    } catch (e) {
      return <UserItem>{};
    }
  }

  get backgroundImage(): string {
    if (!!this.author.avatar_url) {
      return "url('" + this.author.avatar_url + "')";
    } else {
      return "";
    }
  }

  beforeMount() {
    this.$store.dispatch(ActionTypes.GET_AUTHOR, {
      username: this.$props.username
    });
  }
}
